<div class="container">

  <mat-card *ngIf="!isQuoteGeneration">

    <h2 mat-title>Pago de préstamos</h2>
    <account-search resource="loans" (accountDetailEvent)="updateAccountDetail($event)"></account-search>

  </mat-card>

  <div id="search-divider" *ngIf="showLoanSummaryView">
    <mat-card>
      <mat-card-content>
        <div>
          <mat-form-field>
            <mat-label>Cliente</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.parentName" disabled matInput />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Nombre producto</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityName" disabled matInput />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tipo producto</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityType" disabled matInput />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Estado del préstamo</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityStatus.value" disabled matInput />
          </mat-form-field>
          <mat-form-field *ngIf="showLoanRepaymentView">
            <mat-label>Moneda de la cuenta</mat-label>
            <input type="text" [(ngModel)]="loanRepaymentTemplate.currency.code" disabled matInput />
          </mat-form-field>
          <mat-form-field *ngIf="showLoanRepaymentView">
            <mat-label>Próximo pago</mat-label>
            <input type="text" [(ngModel)]="nextRepaymentDate" disabled matInput />
          </mat-form-field>
        </div>

      </mat-card-content>
    </mat-card>
  </div>

  <div id="search-divider" *ngIf="showLoanRepaymentView">
    <mat-card>
      <h2 *ngIf="isQuoteGeneration" mat-title>Detalles de pago</h2>

      <form [formGroup]="repaymentLoanForm">

        <mat-card-content>

          <div fxLayout="column">

            <mat-form-field>
              <mat-label>Moneda de transacción</mat-label>
              <mat-select formControlName="currencyCode" required>
                <mat-option *ngFor="let curr of currencyOptions.selectedCurrencyOptions" [value]="curr.code">
                  ({{ curr.code }}) {{ curr.displayLabel }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="repaymentLoanForm.controls.currencyCode.hasError('required')">
                Moneda de transacción es <strong>obligatoria</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="48%" (click)="repaymentDatePicker.open()" *ngIf="isQuoteGeneration">
              <mat-label>Fecha</mat-label>
              <input matInput [min]="minDate" [matDatepicker]="repaymentDatePicker" required formControlName="transactionDate">
              <mat-datepicker-toggle matSuffix [for]="repaymentDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #repaymentDatePicker></mat-datepicker>
            </mat-form-field>


            <mat-form-field>
              <mat-label>Monto</mat-label>
              <input matInput required formControlName="transactionAmount" [value]="expectedAmountValue">
              <mat-error *ngIf="repaymentLoanForm.controls.transactionAmount.hasError('required')">
                Monto es <strong>obligatorio</strong>
              </mat-error>
            </mat-form-field>
            <span id="expected_amount"> Monto de cuota esperado: {{ expectedAmount }}</span>

            <mat-form-field>
              <mat-label>Tipo de pago</mat-label>
              <mat-select formControlName="paymentTypeId" (selectionChange)="checkForEnableCheckOption($event.value)"
                required>
                <mat-option *ngFor="let paymentType of loanRepaymentTemplate.paymentTypeOptions"
                  [value]="paymentType.id">
                  {{ paymentType.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="repaymentLoanForm.controls.paymentTypeId.hasError('required')">
                Tipo de pago es <strong>obligatorio</strong>
              </mat-error>
            </mat-form-field>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="isPrincipleOnlyPayment">
                Reducir plazo
              </mat-checkbox>
            </div>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="onlyPrincipalPaymentNointerest">
                Solo Capital
              </mat-checkbox>
            </div>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="adjustNextInstallments">
                Ajustar próximas cuotas
              </mat-checkbox>
            </div>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="isEmiUpdate">
                Reducir monto
              </mat-checkbox>
            </div>

            <mat-form-field>
              <mat-label>Mix plazo / Monto</mat-label>
              <input matInput formControlName="noOfInstallments">
            </mat-form-field>

          </div>
          <ng-container *ngIf="showPaymentDetails">
            <mat-form-field>
              <mat-label>No. Cuenta</mat-label>
              <input matInput formControlName="accountNumber">
            </mat-form-field>

            <mat-form-field>
              <mat-label>No. Cheque</mat-label>
              <input matInput formControlName="checkNumber">
            </mat-form-field>

            <mat-form-field>
              <mat-label>Cod. Enrutamiento</mat-label>
              <input matInput formControlName="routingCode">
            </mat-form-field>

            <mat-form-field>
              <mat-label>No. Recibo</mat-label>
              <input matInput formControlName="receiptNumber" required>
              <mat-error *ngIf="repaymentLoanForm.controls.receiptNumber.hasError('required')">
                No. Recibo es <strong>obligatorio</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Banco</mat-label>
              <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="bankNumberDatePicker" required
                formControlName="bankNumber">
              <mat-datepicker-toggle matSuffix [for]="bankNumberDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #bankNumberDatePicker></mat-datepicker>
              <mat-error *ngIf="repaymentLoanForm.controls.bankNumber.hasError('required')">
                Banco es <strong>obligatorio</strong>
              </mat-error>
            </mat-form-field>
          </ng-container>
          <div id="check-grouping" fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" *ngIf="showCheckDetailsView">
            <mat-label fxFlexAlign="center" style="width: 30%;">Mostrar detalles de cheque</mat-label>
            <button type="button" mat-mini-fab color="primary" (click)="addCheckDetails()" fxFlexAlign="right">
              <fa-icon [icon]="!addCheckDetailsFlag ? 'plus-circle' : 'minus-circle'" size="lg"></fa-icon>
            </button>
          </div>
        </mat-card-content>

      </form>

      <form [formGroup]="checkForm">
        <mat-card-content fxLayout="column">
          <mat-form-field *ngIf="checkForm.controls['chequeCountry']">
            <mat-label>País</mat-label>
            <mat-select formControlName="chequeCountry" required [disabled]="true">
              <mat-option *ngFor="let country of loanRepaymentTemplate.countryOptions" [value]="country.id">
                {{ country.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkForm.controls.chequeCountry.hasError('required')">
              País es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>


          <mat-form-field *ngIf="checkForm.controls['chequeBank']">
            <mat-label>Banco</mat-label>
            <mat-select formControlName="chequeBank" required>
              <mat-option *ngFor="let bank of loanRepaymentTemplate.bankOptions" [value]="bank.id">
                {{ bank.description }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkForm.controls.chequeBank.hasError('required')">
              Banco is <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['chequeCurrency']">
            <mat-label>Moneda</mat-label>
            <mat-select formControlName="chequeCurrency" required value="{{repaymentLoanForm.controls['currencyCode'].value }}" [disabled]="false" [disabled]>
              <mat-option *ngFor="let currency of loanRepaymentTemplate.selectedCurrencyOptions"
                [value]="currency.intCode">
                {{ currency.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkForm.controls.chequeCurrency.hasError('required')">
              Moneda es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
          
          <mat-form-field *ngIf="checkForm.controls['checkAccountNumber']">
            <mat-label>No. Cuenta cheque</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="checkAccountNumber" required matInput />
            <mat-error *ngIf="checkForm.controls.checkAccountNumber.hasError('required')">
              No. Cuenta cheque es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['chequeNumber']">
            <mat-label>No. Cheque</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="chequeNumber" required matInput />
            <mat-error *ngIf="checkForm.controls.chequeNumber.hasError('required')">
              No. Cheque es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['checkSecurityNumber']">
            <mat-label>No. Seguridad</mat-label>
            <input type="text" mifosxNumberFormatDirective formControlName="checkSecurityNumber" matInput />
          </mat-form-field>

          <mat-form-field *ngIf="checkForm.controls['checkAmount']">
            <mat-label>Monto cheque</mat-label>
            <input formControlName="checkAmount" matInput />
          </mat-form-field>

          <mat-card-actions *ngIf="checkForm.controls['chequeNumber']" fxLayoutGap="5px" fxLayout="row"
            fxLayout.xs="column" fxLayoutAlign="center">
            <button type="button" mat-raised-button color="secondary" [disabled]="!checkForm.valid"
              (click)="addNewCheck()">Añadir cheque</button>
          </mat-card-actions>

          <table mat-table [dataSource]="checkDetailsTable" *ngIf="checkForm.controls['chequeNumber']">
            <ng-container matColumnDef="checkNumber">
              <th mat-header-cell *matHeaderCellDef> No. Cheque </th>
              <td mat-cell *matCellDef="let element"> {{element.checkNumber}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="checkAmount">
              <th mat-header-cell *matHeaderCellDef> Monto Cheque </th>
              <td mat-cell *matCellDef="let element"> {{element.checkAmount | currency: ' '}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> Acción </th>
              <td mat-cell *matCellDef="let element">
                <button mat-button (click)="removeCheck(element.id)" color="primary">
                  <fa-icon icon="minus-circle"></fa-icon>&nbsp;&nbsp;Remove
                </button>
              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="['checkNumber','checkAmount','id']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['checkNumber','checkAmount','id'];"></tr>

          </table>
        </mat-card-content>
      </form>
      <form [formGroup]="repaymentLoanForm" (ngSubmit)="submit()">
        <mat-card-content fxLayout="column">
          <mat-form-field>
            <mat-label>Nota</mat-label>
            <textarea formControlName="note" matInput></textarea>
          </mat-form-field>


          <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
            <button type="button" mat-raised-button [routerLink]="['../../']">Cancelar</button>
            <button mat-raised-button color="primary" [disabled]="!repaymentLoanForm.valid"
              [disabled]="isDisabled">{{isQuoteGeneration? 'Cotizar' : 'Pagar'}}</button>
          </mat-card-actions>
        </mat-card-content>
      </form>

    </mat-card>
  </div>

</div>